<template>
  <div class="container" v-loading="loading">
    <div class="inside-banner">
      <!-- ElementUI轮播图 -->
      <el-carousel
          class="banner-carousel"
          indicator-position="none"
          loop
          autoplay
          arrow="never"
      >
        <el-carousel-item v-for="(item, index) in topImgList" :key="index">
          <img
              :src="item.src"
              :alt="item.title"
              class="carousel-img"
          />
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="event-title">
      <p class="p1">赛事资讯</p>
      <p class="p2">EVENT INFORMATION</p>
    </div>

    <div class="container-content">
      <div class="article-item article-first"
           v-for="item in articleList"
           :key="item.id"
      >
        <div class="article-img">
          <img
              :src="item.thumbnail"
              :alt="item.title"
              class="first-img"
          />
        </div>
        <div class="article-content" @click="onContestClick(item)">
          <h2 class="article-title">{{ item.title }}</h2>
          <p class="article-desc">{{ item.intro }}</p>
          <p class="article-date">{{ item.time.substring(0,10) }}</p>
        </div>
      </div>

      <!-- 改造：自定义分页组件（和参考代码一致） -->
      <div class="pagination-wrap" v-if="totalPages > 0">
        <button @click="handlePrevPage" :disabled="pageNum === 1">上一页</button>
        <!-- 显示前8页 -->
        <span
            class="page-number"
            v-for="page in showPages"
            :key="page"
            :class="{ active: page === pageNum }"
            @click="handlePageChange(page)"
        >
          {{ page }}
        </span>
        <!-- 省略号（当总页数>8时） -->
        <span v-if="totalPages > 8">...</span>
        <!-- 最后一页 -->
        <span class="page-number" @click="handlePageChange(totalPages)" v-if="totalPages > 8">
          {{ totalPages }}
        </span>
        <button @click="handleNextPage" :disabled="pageNum === totalPages">下一页</button>

        <span>到第</span>
        <input
            type="number"
            v-model.number="jumpPage"
            min="1"
            :max="totalPages"
            @keydown.enter="handleJumpPage"
        />
        <button @click="handleJumpPage">确定</button>
      </div>

      <!-- 空数据提示 -->
      <div class="empty-tip" v-if="articleList.length === 0 && !loading">
        暂无相关文章
      </div>
    </div>
  </div>
</template>

<script>
import {NodeIdEnum} from "@/enums/nodeIdEnum";
import {getImgList, selectArticleList} from "@/api/home";
import {ImageTypeEnum} from "@/enums/imageTypeEnum";

export default {
  data() {
    return {
      loading: false,
      topImgList:[],
      // 文章列表数据
      articleList: [],
      // 分页参数（和参考代码一致）
      pageNum: 1,        // 当前页码
      pageSize: 5,       // 每页条数
      totalPages: 0,     // 总页数
      jumpPage: 1,       // 跳转页码
      showPages: [1,2,3,4,5,6,7,8], // 分页栏显示前8页
      articleType: "",   // 当前文章类型
      // 常量配置
      CONST: {
        API_TYPE: "contest_news",
      }
    }
  },
  created() {
    // 从路由获取文章类型
    this.articleType = this.$route.query.articleType;
    this.getBannerList();  //初始化获取图片
    this.fetchArticleList(); // 初始化获取文章列表
  },
  methods: {
    //获取图片
    async getBannerList() {
      try {
        this.loading = true;
        const res = await getImgList(ImageTypeEnum.EVENT_BANNER_LIST.value);
        const dataList = res.data || [];
        this.topImgList = dataList.filter(item => item.classify === ImageTypeEnum.EVENT_BANNER_LIST.value && item.src);
      } catch (error) {
        console.error("获取轮播图失败：", error);
        this.$message?.error("轮播图加载失败，请稍后重试");
      } finally {
        this.loading = false;
      }
    },

    // 获取文章列表（调整为参考代码的分页逻辑）
    async fetchArticleList() {
      try {
        this.loading = true;
        const res = await selectArticleList(NodeIdEnum.ARTICLE_TYPE_HYXW_ID.value, this.pageNum, this.pageSize);
        if (res.code === 200) {
          this.articleList = res.data.rows || [];
          // 计算总页数（和参考代码一致）
          this.totalPages = Math.ceil(res.data.total / this.pageSize) || 0;
        } else {
          this.$message.error(res.msg || "获取文章列表失败");
        }
      } catch (error) {
        console.error("获取文章列表失败：", error);
        this.$message.error("网络异常，请稍后重试");
      } finally {
        this.loading = false;
      }
    },

    // 上一页（参考代码逻辑）
    handlePrevPage() {
      if (this.pageNum > 1) {
        this.pageNum--;
        this.fetchArticleList();
      }
    },

    // 下一页（参考代码逻辑）
    handleNextPage() {
      if (this.pageNum < this.totalPages) {
        this.pageNum++;
        this.fetchArticleList();
      }
    },

    // 切换页码（参考代码逻辑）
    handlePageChange(page) {
      this.pageNum = page;
      this.fetchArticleList();
    },

    // 跳转到指定页（参考代码逻辑）
    handleJumpPage() {
      if (this.jumpPage < 1 || this.jumpPage > this.totalPages) {
        this.$message.warning("页码超出范围");
        return;
      }
      this.pageNum = this.jumpPage;
      this.fetchArticleList();
    },

    // 文章点击跳转
    onContestClick(item){
      this.$router.push({
        path: "/article",
        query: { articleId:item.id,type: item.type }
      });
    }
  }
}
</script>

<style scoped lang="scss">
// 统一盒模型
*,
*::before,
*::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
// 基础浮动类（兼容旧类名）
.fl { float: left; }
.fr { float: right; }
// 清除浮动
.clearfix::after {
  content: '';
  display: block;
  clear: both;
}

.container{
  position: relative;
  width: 100%;
  max-width: 1920px; // 限制最大宽度，适配大屏
  margin: 0 auto;
}

// Banner容器
.inside-banner {
  position: relative;
  margin-top: 100px;
  width: 100%;
  overflow: hidden;

  // 平板适配
  @media (max-width: 768px) {
    margin-top: 80px;
  }
  // 手机适配
  @media (max-width: 480px) {
    margin-top: 60px;
  }
}

// ElementUI轮播图容器样式
.banner-carousel {
  width: 100%;
  height: 880px !important; // 大屏高度

  // 平板适配
  @media (max-width: 768px) {
    height: 280px !important; // 平板适当调高，提升显示效果
  }
  // 手机适配（使用vw单位，适配不同屏幕宽度）
  @media (max-width: 480px) {
    height: 50vw !important; // 占屏幕宽度的50%，比例更合理
  }

  :deep(.el-carousel__container) {
    height: 100%;
  }

  :deep(.el-carousel-item) {
    height: 100%;
  }
}

// 轮播图图片样式
.carousel-img {
  width: 100%;
  height: 100%;
  object-fit: cover; // 保持比例并覆盖容器
  object-position: center; // 居中显示
  // 移动端优化图片显示
  @media (max-width: 480px) {
    object-fit: contain; // 确保图片完整显示
    background: #f5f5f5; // 避免空白区域太突兀
  }
}

// 赛事标题样式
.event-title{
  max-width: 1600px;
  font-size: 50px;
  color: #0f0f0f;
  text-align: center;
  border-bottom: 2px solid #0f0f0f;
  margin: 0 auto;
  padding: 0 10px; // 避免标题贴边

  .p1{
    padding-top: 70px;
    letter-spacing: 10px;
  }
  .p2{
    padding-bottom: 70px;
    letter-spacing: 25px;
  }

  // 平板适配
  @media (max-width: 768px) {
    font-size: 30px;
    .p1 {
      padding-top: 40px;
      letter-spacing: 8px;
    }
    .p2 {
      padding-bottom: 40px;
      letter-spacing: 15px;
    }
  }

  // 手机适配
  @media (max-width: 480px) {
    font-size: 20px;
    border-bottom: 1px solid #0f0f0f; // 减小边框厚度
    .p1 {
      padding-top: 25px;
      letter-spacing: 5px;
    }
    .p2 {
      padding-bottom: 25px;
      letter-spacing: 8px;
    }
  }
}

// 内容容器
.container-content {
  max-width: 1600px;
  margin: 50px auto;
  padding: 0 10px;

  // 首条文章样式
  .article-first {
    display: flex;
    gap: 24px;
    padding: 20px 0;
    border-bottom: 2px solid #0f0f0f;
    margin-bottom: 30px;
    cursor: pointer;

    .article-img {
      flex: 0 0 320px;
      height: 200px;
      overflow: hidden;

      .first-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 4px;
        transition: transform 0.3s;
      }

      &:hover .first-img {
        transform: scale(1.03);
      }
    }

    .article-content {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      gap: 12px;

      .article-title {
        font-size: 22px;
        font-weight: bold;
        color: #333;
        margin: 0;
        line-height: 1.5;
        transition: color 0.2s;

        &:hover {
          color: #d26b6b;
        }
      }

      .article-date {
        font-size: 14px;
        color: #999;
        margin: 0;
      }

      .article-desc {
        font-size: 16px;
        color: #666;
        margin: 0;
        line-height: 1.6;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
    }
  }

  // ========== 核心：参考代码的分页样式 ==========
  .pagination-wrap {
    margin-top: 40px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    flex-wrap: wrap;
    // 移动端适配
    @media (max-width: 768px) {
      margin-top: 20px;
      gap: 5px;
    }

    button {
      padding: 4px 10px;
      border: 1px solid #eee;
      background: #fff;
      cursor: pointer;
      border-radius: 4px;
      font-size: 14px;
      // 移动端缩小按钮
      @media (max-width: 768px) {
        padding: 3px 8px;
        font-size: 12px;
      }
      // 禁用状态
      &:disabled {
        cursor: not-allowed;
        color: #999;
        background: #f5f5f5;
      }
      // hover效果（参考代码的#f6c279主色）
      &:hover:not(:disabled) {
        background: #f6c279;
        color: #fff;
        border-color: #f6c279;
      }
    }

    // 页码数字样式
    .page-number {
      width: 28px;
      height: 28px;
      line-height: 28px;
      text-align: center;
      border-radius: 4px;
      cursor: pointer;
      font-size: 14px;
      border: 1px solid #eee;
      // 移动端缩小页码
      @media (max-width: 768px) {
        width: 24px;
        height: 24px;
        line-height: 24px;
        font-size: 12px;
      }
      // 当前页样式（参考代码的#f6c279）
      &.active {
        background: #f6c279;
        color: #fff;
      }
      // 非当前页hover
      &:hover:not(.active) {
        background: #f5f5f5;
      }
    }

    // 跳转输入框
    input {
      width: 45px;
      height: 28px;
      text-align: center;
      border: 1px solid #eee;
      border-radius: 4px;
      outline: none;
      font-size: 14px;
      // 移动端缩小输入框
      @media (max-width: 768px) {
        width: 40px;
        height: 24px;
        font-size: 12px;
      }
      // 聚焦样式
      &:focus {
        border-color: #f6c279;
      }
    }

    // 跳转文字
    span:not(.page-number) {
      font-size: 14px;
      // 移动端缩小文字
      @media (max-width: 768px) {
        font-size: 12px;
      }
    }
  }

  // 空数据提示
  .empty-tip {
    text-align: center;
    padding: 50px 0;
    color: #999;
    font-size: 16px;

    // 手机适配
    @media (max-width: 480px) {
      padding: 30px 0;
      font-size: 14px;
    }
  }

  // 平板适配
  @media (max-width: 768px) {
    margin: 30px auto;

    .article-first {
      flex-direction: column; // 首条改为上下布局
      gap: 15px;
      padding: 15px 0;
      margin-bottom: 20px;

      .article-img {
        flex: 0 0 auto;
        height: auto;

        .first-img {
          height: auto;
          min-height: 180px;
        }
      }

      .article-content {
        gap: 10px;

        .article-title {
          font-size: 18px;
        }

        .article-desc {
          font-size: 14px;
        }
      }
    }
  }

  // 手机适配（480px以下）
  @media (max-width: 480px) {
    margin: 20px auto;

    .article-first {
      border-bottom: 1px solid #0f0f0f; // 减小边框厚度
      gap: 10px;
      padding: 10px 0;
      margin-bottom: 15px;

      .article-img {
        .first-img {
          min-height: 120px;
          border-radius: 2px; // 减小圆角，适配小屏
        }
      }

      .article-content {
        gap: 8px;

        .article-title {
          font-size: 16px;
          line-height: 1.4;
        }

        .article-desc {
          font-size: 13px;
          line-height: 1.5;
          -webkit-line-clamp: 3; // 移动端多显示一行描述
        }

        .article-date {
          font-size: 12px;
        }
      }
    }
  }
}
</style>